// removed by extract-text-webpack-plugin
module.exports = {"vpCampaignLandingPageContainer":"vpCampaignLandingPageContainer___1mRAI","vpCampaignLandingInnerWrapper":"vpCampaignLandingInnerWrapper___ZiYj5","vpPreviewInfo":"vpPreviewInfo___3oDMX","vpCampaignLoadingError":"vpCampaignLoadingError___3EnTr","vpSubmitSection":"vpSubmitSection___1QHCA","fullBranding":"fullBranding___2bB6T","logoBranding":"logoBranding___17_RU","profileBranding":"profileBranding___3Omxz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/CampaignLandingPage/LandingPage.module.less
// module id = 3772
// module chunks = 31